<template>
  <div class="card">
    <div class="bg-blue-light px-1 rounded pb-2">
      <TitleButton
          class="mt-1"
          btnTitle="List"
          :showBtn="true"
          :showAddNew="false"
          :title="headerTitle"
          @onClickCloseButton="navigateToListPage"
      />
    </div>
    <div class="px-2 mt-1">
      <div class="card card-height">
        <div class="row mt-2 gy-1">
          <div class="row mt-1">
            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="col-form-label">Name</label>
              <input
                  class="form-control invoice-edit-input  "
                  tabindex="1"
                  type="text"
                  placeholder="Name...."
                  v-model="formData.name"
              >
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="col-form-label">Type</label>
              <v-select
                  placeholder="Select Type"
                  v-model="formData.type"
                  :options="areaType"
                  :reduce="name => name.value"
                  label="name"
              />
            </div>

            <div class="col-12 col-md-3">
              <label class="col-form-label">Parent Location</label>
              <AsyncSelect
                  v-model="parentLocation"
                  placeholder="Select Parent Location"
                  :api-service="fetchParentLocationList"
                  :additional-query="parentLocationQuery"
                  :key="parentLocationRenderKey"
              />
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="col-form-label">Amount</label>
              <input
                  class="form-control"
                  step="any"
                  type="number"
                  placeholder="Amount...."
                  v-model="formData.amount"
              >
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="col-form-label">Status</label>
              <v-select
                  placeholder="Select Status"
                  v-model="formData.status"
                  :options="status"
                  :reduce="name => name.value"
                  label="name"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-2 d-flex justify-content-start justify-content-sm-center px-2 gap-1 flex-wrap pb-2">
      <hr class="hr-full-width mb-1">
      <button :disabled="saveButtonLoader || saveNewButtonLoader" @click="saveAP()"
              class="btn btn-primary">
        Save
      </button>
      <button :disabled="saveButtonLoader || saveNewButtonLoader" @click="saveAP(false)"
              class="btn btn-primary">Save & New
      </button>
      <button @click="navigateToListPage" class="btn btn-outline-secondary">Cancel</button>
    </div>

    <GlobalLoader/>
  </div>
</template>
<script setup>
import handleOrganizationSetting from "@/services/modules/organizationSettings";
import {computed, inject, onMounted, ref, watch} from 'vue'
import {useRoute, useRouter} from "vue-router";
import TitleButton from '@/components/atom/TitleButton'
import GlobalLoader from "@/components/atom/GlobalLoader.vue";
import {useStore} from "vuex";
import handleInventory from "@/services/modules/inventory";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";

const store = useStore();
const router = useRouter()
const route = useRoute()
const showError = inject('showError');
const showSuccess = inject('showSuccess')
const companyId = computed(() => {
  return route.params.companyId
})

let loader =ref(false)
let parentLocation =ref('')
let saveButtonLoader = ref(false)
let saveNewButtonLoader = ref(false)
let isCreate = ref(true)
let parentLocationRenderKey = ref(0)
let headerTitle = ref("Add Location")
let contacts = ref([])
let locations = ref([])
let accountPayable = ref([])
let locationEditData = ref({})
const status = ref([]);
const areaType = ref([]);

let locationData = {}
let formData = ref({
  name:'',
  type:'',
  area_id:'',
  amount:'',
})

const parentLocationQuery = ref({
  type: '',
});

function navigateToListPage() {
  delete route.query.locationId;
  router.push({name: `location-list`, params: route.params, query: route.query});
}

const {
  fetchParentLocationList,
  updateLocation,
  fetchSingleLocation,
  storeLocation,
} = handleOrganizationSetting()
const { fetchHome } = handleInventory()

function saveAP(redirect = true) {
  if (isCreate.value) {
    handleSubmit(redirect);
  } else {
    handleUpdate(redirect);
  }
}

function handleSubmit(redirect) {
  locationData.status = formData.value.status
  locationData.name = formData.value.name;
  locationData.type = formData.value.type;
  locationData.area_id =  parentLocation.value ? parentLocation.value.id : null
  locationData.amount = formData.value.amount;

  createAP(redirect);
}

function handleUpdate(redirect) {
  locationData.id = formData.value.id;
  locationData.status = formData.value.status
  locationData.name = formData.value.name;
  locationData.type = formData.value.type;
  locationData.area_id =  parentLocation.value ? parentLocation.value.id : null
  locationData.amount = formData.value.amount;

  updateAPData(redirect);
}

function createAP(redirect = true) {
  storeLocation(locationData, getQuery())
      .then(res => {
        if (!res.status) {
          showError(res.message)
          return
        }
         showSuccess(res.message)
         if (redirect) navigateToListPage()
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
        loader.value = false
      })
}

function updateAPData(redirect = true) {
  updateLocation(locationData, locationData.id, getQuery())
      .then(res => {
        if (!res.status) {
          showError(res.message)
          return
        }
         showSuccess(res.message);
         if (redirect) navigateToListPage()
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
        loader.value = false
      })
}

function getQuery() {
  return `?company_id=${route.params.companyId}`;
}

function setFormData() {
  headerTitle.value = "Update Location";
  formData.value.id =  locationEditData.value.id;
  formData.value.type = locationEditData.value.type;
  formData.value.name = locationEditData.value.name;
  formData.value.area_id = locationEditData.value.area_id;
  parentLocation.value = {
    id: locationEditData.value.area_id,
    name: locationEditData.value.parent_area_name
  }
  formData.value.amount = locationEditData.value.amount;
  formData.value.status = locationEditData.value.status;
}

const getHome = async () => {
  let query = getQuery();
  await fetchHome(query).then(res => {
    if (!res.status){
      status.value = [];
      return
    }
    if (res.data && res.data.status) {
      status.value = Object.keys(res.data.status)
          .filter(key => ["active", "inactive"].includes(key))
          .map(key => ({
            value: key,
            name: res.data.status[key]
          }));
    }
    if (res.data && res.data.area_type) {
      areaType.value = Object.keys(res.data.area_type)
          .map(key => ({
            value: key,
            name: res.data.area_type[key]
          }));
    }

  }).catch(err => {
    console.log(err)
  })
}

function onPageReload() {
  loader.value=true

  Promise.all([
    getHome(),

  ]).finally(() => {
    loader.value = false
  })

  if(route.query.locationId && route.query.locationId !== '' && route.query.locationId !== undefined){
    isCreate.value = false;
    const fetchLocation = fetchSingleLocation(route.query.locationId, getQuery());
    fetchLocation.then(res2 => {
      locationEditData.value = res2.data;
      setFormData();
    });
  }
}

watch(() => formData.value.type, (newValue, oldValue) => {
  parentLocation.value = null;
  parentLocationQuery.value.type = '';

  if (locationEditData.value && parentLocationRenderKey.value === 0){
    parentLocation.value = {
      id: locationEditData.value.area_id,
      name: locationEditData.value.parent_area_name
    }
  }

  parentLocationRenderKey.value += 1;

  if(newValue) {
    parentLocationQuery.value.type = newValue;
  }
})

onMounted(() => {
  onPageReload();
})
</script>